import { Injectable } from '@angular/core';
import { Http, Headers, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import _ from 'lodash';

export const honeywellDeviceTypes = {
  Thermostat: {
    model: 'honeywell-lyric-round-thermostat'
  }
};

export type HoneywellDevice = {
  deviceId: string;
  name: string;
  type: string;
  locationId: string;
  refresh_token: string;
};

@Injectable()
export class HoneywellService {
  public static readonly HONEYWELL_MODEL = 'honeywell';
  public static readonly ACCESS_TOKEN_URL = 'https://api.honeywell.com/oauth2/token';
  public static readonly API_URL = 'https://api.honeywell.com/v2/';

  constructor(private http: Http) {}

  public getHoneywellTokens(account: any): any {
    const honeywellAccount = _.get(account, 'externalAccounts', []).find(
      (acc: any) => acc.type === HoneywellService.HONEYWELL_MODEL
    );

    return honeywellAccount
      ? {
          accessToken: _.get(honeywellAccount, 'access_token'),
          refreshToken: _.get(honeywellAccount, 'data.refresh_token')
        }
      : null;
  }

  public requestAccessToken(
    clientId: string,
    clientSecret: string,
    code: string,
    redirectUri: string
  ): Observable<any> {
    const headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    headers.append(
      'Authorization',
      `Basic ${this.encodeAuthHeader(clientId, clientSecret)}`
    );

    const bodyParams = new URLSearchParams();
    bodyParams.append('grant_type', 'authorization_code');
    bodyParams.append('code', code);
    bodyParams.append('redirect_uri', redirectUri);

    return this.http
      .post(HoneywellService.ACCESS_TOKEN_URL, bodyParams, { headers })
      .map((res) => res.json());
  }

  public requestRefreshToken(
    clientId: string,
    clientSecret: string,
    refresh_token: string
  ): Observable<any> {
    const headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    headers.append(
      'Authorization',
      `Basic ${this.encodeAuthHeader(clientId, clientSecret)}`
    );

    const bodyParams = new URLSearchParams();
    bodyParams.append('grant_type', 'refresh_token');
    bodyParams.append('refresh_token', refresh_token);

    return this.http
      .post(HoneywellService.ACCESS_TOKEN_URL, bodyParams, { headers })
      .map((res) => res.json());
  }

  private encodeAuthHeader(clientId: string, clientSecret: string): string {
    return btoa(`${clientId}:${clientSecret}`);
  }

  public readAllData(accessToken: string, clientId: string): Observable<any> {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', `Bearer ${accessToken}`);

    return this.http
      .get(HoneywellService.API_URL + `locations?apikey=${clientId}`, {
        headers
      })
      .map((res) => res.json());
  }
}
